import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Material } from "../../material/shared/material.model";
import { MaterialEspecificacao } from "../shared/material-especificacao.model";
import { MaterialEspecificacaoService } from "../shared/material-especificacao.service";
import { MaterialService } from "../../material/shared/material.service";
import { materialEspecificacaoTitle } from "../../material/shared/data.service";
import { UtilService } from "../../../../shared/services/util.service";
import { newRouteFemale, editRoute } from "../../../../shared/services/data.service";

declare var swal: any;

@Component({
    template: require('./material-especificacao-register.component.html')
})

export class MaterialEspecificacaoRegisterComponent implements OnInit {
    materialEspecificacaoTitle: any = materialEspecificacaoTitle;
    actionTitle: string;
    itemObject: any = new MaterialEspecificacao();

    private materialObject: Material = new Material();

    constructor(
        private _service: MaterialEspecificacaoService,
        private _materialService: MaterialService,
        private _utilService: UtilService,
        private _route: ActivatedRoute
    ){}

    ngOnInit() {
        let id = +this._route.snapshot.params['id'];
        this.itemObject = this._service.getStorage();
        this.materialObject = this.itemObject.material;

        if (id) {
            this.actionTitle = editRoute;
            this.itemObject.id = id;
        } else {
            this.actionTitle = newRouteFemale;
        }

    }

    onclickSend(arg: any) {
        if (this.actionTitle === editRoute) {
            this.onEdit(arg);
        } else {
            this.onSave(arg);
        }
    }

    onclickGoToMaterialDetail() {
        this._materialService.goToDetail(this.materialObject.id);
    }

    onclickCancel() {
        this.onclickGoToMaterialDetail();
    }

    onSave(arg: any) {
        this.onDone(arg);
    }

    onEdit(arg: any) {
        this.onDone(arg);
    }

    private onDone = (function(Response: any) {
        if (!Response.error) {
            if (this.actionTitle === editRoute) {
              this._utilService.swalMessageEditSuccess();
            } else {
              this._utilService.swalMessageAddSuccess();
            }
            this.onclickGoToMaterialDetail();
        } else {
          this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-especificacao/material-especificacao-register/material-especificacao-register.component.ts
 **/